import { get } from "svelte/store"
import { _ } from "svelte-i18n"

export let mappingCart = {
    refNumber: [get(_)("cart.mapping.refNumber")],
    number: [get(_)("cart.mapping.number")],
    endCustomerEmail: [get(_)("cart.mapping.endCustomerEmail")],
    endCustomerPhone: [get(_)("cart.mapping.endCustomerPhone")],
    endCustomerAddress: [
        get(_)("cart.mapping.endCustomerAddress.label"),
        {
            name1: [get(_)("cart.mapping.endCustomerAddress.name1")],
            name2: [get(_)("cart.mapping.endCustomerAddress.name2")],
            name3: [get(_)("cart.mapping.endCustomerAddress.name3")],
            street: [get(_)("cart.mapping.endCustomerAddress.street")],
            country: [get(_)("cart.mapping.endCustomerAddress.country")],
            postcode: [get(_)("cart.mapping.endCustomerAddress.postcode")],
            city: [get(_)("cart.mapping.endCustomerAddress.city")],
        },
    ],
    endCustomerVAT: [get(_)("cart.mapping.endCustomerVAT")],
    sumEndCustomerPrice: [get(_)("cart.mapping.sumEndCustomerPrice")],
    sumEndCustomerPriceGross: [get(_)("cart.mapping.sumEndCustomerPriceGross")],
    type: [
        get(_)("cart.mapping.type.label"),
        {
            1: [get(_)("cart.mapping.type.1")],
            2: [get(_)("cart.mapping.type.2")],
        },
    ],
    source: [
        get(_)("cart.mapping.source.label"),
        {
            10: [get(_)("cart.mapping.source.10")],
            20: [get(_)("cart.mapping.source.20")],
            30: [get(_)("cart.mapping.source.30")],
            31: [get(_)("cart.mapping.source.31")],
            40: [get(_)("cart.mapping.source.40")],
            50: [get(_)("cart.mapping.source.50")],
            60: [get(_)("cart.mapping.source.60")],
        },
    ],
    statusSummary: [
        get(_)("cart.mapping.statusSummary.label"),
        {
            created: [
                get(_)("cart.mapping.statusSummary.created.label"),
                {
                    0: get(_)("cart.mapping.statusSummary.created.0"),
                    30: get(_)("cart.mapping.statusSummary.created.30"),
                    100: get(_)("cart.mapping.statusSummary.created.100"),
                },
            ],
            emailed: [
                get(_)("cart.mapping.statusSummary.emailed.label"),
                {
                    0: get(_)("cart.mapping.statusSummary.emailed.0"),
                    100: get(_)("cart.mapping.statusSummary.emailed.100"),
                },
            ],
        },
    ],
    orderedSummary: [
        get(_)("cart.mapping.orderedSummary.label"),
        {
            ordered: [
                get(_)("cart.mapping.orderedSummary.ordered.label"),
                {
                    0: get(_)("cart.mapping.orderedSummary.ordered.0"),
                    100: get(_)("cart.mapping.orderedSummary.ordered.100"),
                },
            ],
            orderedCount: [get(_)("cart.mapping.orderedSummary.orderedCount")],
        },
    ],
    endCustomerFullAddress: [
        get(_)("cart.mapping.endCustomerFullAddress.label"),
        {
            id: [get(_)("cart.mapping.endCustomerFullAddress.id")],
            insertTime: [get(_)("cart.mapping.endCustomerFullAddress.insertTime")],
            updateTime: [get(_)("cart.mapping.endCustomerFullAddress.updateTime")],
            dealerNumber: [get(_)("cart.mapping.endCustomerFullAddress.dealerNumber")],
            type: [
                get(_)("cart.mapping.endCustomerFullAddress.type.label"),
                {
                    person: [get(_)("cart.mapping.endCustomerFullAddress.type.person")],
                    company: [get(_)("cart.mapping.endCustomerFullAddress.type.company")],
                },
            ],
            vat: [get(_)("cart.mapping.endCustomerFullAddress.vat")],
            company: [
                get(_)("cart.mapping.endCustomerFullAddress.company.label"),
                {
                    name: [get(_)("cart.mapping.endCustomerFullAddress.company.name")],
                    vatId: [get(_)("cart.mapping.endCustomerFullAddress.company.vatId")],
                    firstname: [get(_)("cart.mapping.endCustomerFullAddress.company.firstname")],
                    lastname: [get(_)("cart.mapping.endCustomerFullAddress.company.lastname")],
                    paymentTerms: [get(_)("cart.mapping.endCustomerFullAddress.company.paymentTerms")],
                },
            ],
            person: [
                get(_)("cart.mapping.endCustomerFullAddress.person.label"),
                {
                    salutation: [get(_)("cart.mapping.endCustomerFullAddress.person.salutation")],
                    firstname: [get(_)("cart.mapping.endCustomerFullAddress.person.firstname")],
                    lastname: [get(_)("cart.mapping.endCustomerFullAddress.person.lastname")],
                    parentCompany: [get(_)("cart.mapping.endCustomerFullAddress.person.parentCompany")],
                },
            ],
            location: [
                get(_)("cart.mapping.endCustomerFullAddress.location.label"),
                {
                    street: [get(_)("cart.mapping.endCustomerFullAddress.location.street")],
                    houseNumber: [get(_)("cart.mapping.endCustomerFullAddress.location.houseNumber")],
                    supplement: [get(_)("cart.mapping.endCustomerFullAddress.location.supplement")],
                    postcode: [get(_)("cart.mapping.endCustomerFullAddress.location.postcode")],
                    city: [get(_)("cart.mapping.endCustomerFullAddress.location.city")],
                    country: [get(_)("cart.mapping.endCustomerFullAddress.location.country")],
                },
            ],
            contact: [
                get(_)("cart.mapping.endCustomerFullAddress.contact.label"),
                {
                    phone: [get(_)("cart.mapping.endCustomerFullAddress.contact.phone")],
                    fax: [get(_)("cart.mapping.endCustomerFullAddress.contact.fax")],
                    email: [get(_)("cart.mapping.endCustomerFullAddress.contact.email")],
                    website: [get(_)("cart.mapping.endCustomerFullAddress.contact.website")],
                },
            ],
            customerNumber: [get(_)("cart.mapping.endCustomerFullAddress.customerNumber")],
            priceCalculation: [get(_)("cart.mapping.endCustomerFullAddress.priceCalculation")],
            notModifyablePCalc: [get(_)("cart.mapping.endCustomerFullAddress.notModifyablePCalc")],
            deliveryAddress: [
                get(_)("cart.mapping.endCustomerFullAddress.deliveryAddress.label"),
                {
                    salutation: [get(_)("cart.mapping.endCustomerFullAddress.deliveryAddress.salutation")],
                    name1: [get(_)("cart.mapping.endCustomerFullAddress.deliveryAddress.name1")],
                    name2: [get(_)("cart.mapping.endCustomerFullAddress.deliveryAddress.name2")],
                    name3: [get(_)("cart.mapping.endCustomerFullAddress.deliveryAddress.name3")],
                    street: [get(_)("cart.mapping.endCustomerFullAddress.deliveryAddress.street")],
                    country: [get(_)("cart.mapping.endCustomerFullAddress.deliveryAddress.country")],
                    postcode: [get(_)("cart.mapping.endCustomerFullAddress.deliveryAddress.postcode")],
                    city: [get(_)("cart.mapping.endCustomerFullAddress.deliveryAddress.city")],
                    phone: [get(_)("cart.mapping.endCustomerFullAddress.deliveryAddress.phone")],
                    fax: [get(_)("cart.mapping.endCustomerFullAddress.deliveryAddress.fax")],
                    email: [get(_)("cart.mapping.endCustomerFullAddress.deliveryAddress.email")],
                },
            ],
        },
    ],
    dealerNumber: [get(_)("cart.mapping.dealerNumber")],
    inquiryDate: [get(_)("cart.mapping.inquiryDate")],
    inquiryNumber: [get(_)("cart.mapping.inquiryNumber")],
    receiptDate: [get(_)("cart.mapping.receiptDate")],
    releaseDate: [get(_)("cart.mapping.releaseDate")],
    constructionProject: [get(_)("cart.mapping.constructionProject")],
    constructionSite: [get(_)("cart.mapping.constructionSite")],
    commission: [get(_)("cart.mapping.commission")],
    residentialUnitsCount: [get(_)("cart.mapping.residentialUnitsCount")],
    deliveryAddress: [
        get(_)("cart.mapping.deliveryAddress.label"),
        {
            salutation: [get(_)("cart.mapping.deliveryAddress.salutation")],
            name1: [get(_)("cart.mapping.deliveryAddress.name1")],
            name2: [get(_)("cart.mapping.deliveryAddress.name2")],
            name3: [get(_)("cart.mapping.deliveryAddress.name3")],
            street: [get(_)("cart.mapping.deliveryAddress.street")],
            country: [get(_)("cart.mapping.deliveryAddress.country")],
            postcode: [get(_)("cart.mapping.deliveryAddress.postcode")],
            city: [get(_)("cart.mapping.deliveryAddress.city")],
            phone: [get(_)("cart.mapping.deliveryAddress.phone")],
            fax: [get(_)("cart.mapping.deliveryAddress.fax")],
            email: [get(_)("cart.mapping.deliveryAddress.email")],
        },
    ],
    inquiryContact: [
        get(_)("cart.mapping.inquiryContact.label"),
        {
            name: [get(_)("cart.mapping.inquiryContact.name")],
        },
    ],
    endCustomer: [
        get(_)("cart.mapping.endCustomer.label"),
        {
            name: [get(_)("cart.mapping.endCustomer.name")],
        },
    ],
    sumNetPrice: [get(_)("cart.mapping.sumNetPrice")],
    sumRetailPrice: [get(_)("cart.mapping.sumRetailPrice")],
    clerk: [
        get(_)("cart.mapping.clerk.label"),
        {
            name: [get(_)("cart.mapping.clerk.name")],
            email: [get(_)("cart.mapping.clerk.email")],
        },
    ],
    internalClerk: [
        get(_)("cart.mapping.internalClerk.label"),
        {
            name: [get(_)("cart.mapping.internalClerk.name")],
        },
    ],
    additionalPositions: [
        get(_)("cart.mapping.additionalPositions.label"),
        {
            number: [get(_)("cart.mapping.additionalPositions.number")],
            service: [get(_)("cart.mapping.additionalPositions.service")],
            description: [get(_)("cart.mapping.additionalPositions.description")],
            netPrice: [get(_)("cart.mapping.additionalPositions.netPrice")],
            amount: [get(_)("cart.mapping.additionalPositions.amount")],
        },
    ],
    documentTemplateTextContent: [
        get(_)("cart.mapping.documentTemplateTextContent.label"),
        {
            emailSubject: [get(_)("cart.mapping.documentTemplateTextContent.emailSubject")],
            emailBody: [get(_)("cart.mapping.documentTemplateTextContent.emailBody")],
            pdfIntro: [get(_)("cart.mapping.documentTemplateTextContent.pdfIntro")],
            pdfOutro: [get(_)("cart.mapping.documentTemplateTextContent.pdfOutro")],
            preLetter: [get(_)("cart.mapping.documentTemplateTextContent.preLetter")],
            deliveryTime: [get(_)("cart.mapping.documentTemplateTextContent.deliveryTime")],
            paymentTerms: [get(_)("cart.mapping.documentTemplateTextContent.paymentTerms")],
            contact: [
                get(_)("cart.mapping.documentTemplateTextContent.contact.label"),
                {
                    useLoggedInUserAsDefault: [
                        get(_)("cart.mapping.documentTemplateTextContent.contact.useLoggedInUserAsDefault"),
                    ],
                    name: [get(_)("cart.mapping.documentTemplateTextContent.contact.name")],
                    phone: [get(_)("cart.mapping.documentTemplateTextContent.contact.phone")],
                    email: [get(_)("cart.mapping.documentTemplateTextContent.contact.email")],
                    webUrl: [get(_)("cart.mapping.documentTemplateTextContent.contact.webUrl")],
                },
            ],
        },
    ],
    positions: [
        get(_)("cart.mapping.positions.label"),
        {
            number: [get(_)("cart.mapping.positions.number")],
            type: [get(_)("cart.mapping.positions.type")],
            quantity: [get(_)("cart.mapping.positions.quantity")],
            orderQuantity: [get(_)("cart.mapping.positions.orderQuantity")],
            color: [
                get(_)("cart.mapping.positions.color.label"),
                {
                    code: [get(_)("cart.mapping.positions.color.code")],
                    name: [get(_)("cart.mapping.positions.color.name")],
                },
            ],
            additionalItems: [
                get(_)("cart.mapping.positions.additionalItems.label"),
                {
                    number: [get(_)("cart.mapping.positions.additionalItems.number")],
                    description: [get(_)("cart.mapping.positions.additionalItems.description")],
                    netPrice: [get(_)("cart.mapping.positions.additionalItems.netPrice")],
                    service: [get(_)("cart.mapping.positions.additionalItems.service")],
                    amount: [get(_)("cart.mapping.positions.additionalItems.amount")],
                },
            ],
            state: [
                get(_)("cart.mapping.positions.state.label"),
                {
                    code: [get(_)("cart.mapping.positions.state.code")],
                    description: [get(_)("cart.mapping.positions.state.description")],
                    blockingIndicator: [get(_)("cart.mapping.positions.state.blockingIndicator")],
                },
            ],
            delivery: [
                get(_)("cart.mapping.positions.delivery.label"),
                {
                    plannedDate: [get(_)("cart.mapping.positions.delivery.plannedDate")],
                    plannedDateNew: [get(_)("cart.mapping.positions.delivery.plannedDateNew")],
                    plannedWeek: [get(_)("cart.mapping.positions.delivery.plannedWeek")],
                    actualDate: [get(_)("cart.mapping.positions.delivery.actualDate")],
                    shippingCompany: [get(_)("cart.mapping.positions.delivery.shippingCompany")],
                },
            ],
            origin: [
                get(_)("cart.mapping.positions.origin.label"),
                {
                    operationNumber: [get(_)("cart.mapping.positions.origin.operationNumber")],
                    positionNumber: [get(_)("cart.mapping.positions.origin.positionNumber")],
                },
            ],
            residentialUnitsCount: [get(_)("cart.mapping.positions.residentialUnitsCount")],
            residentialUnitsCountTotal: [get(_)("cart.mapping.positions.residentialUnitsCountTotal")],
        },
    ],

    rikNumber: [get(_)("cart.mapping.positions.rikNumber")],
    productGroup: [get(_)("cart.mapping.positions.productGroup")],
    modelGroup: [get(_)("cart.mapping.positions.modelGroup")],
    installationType: [get(_)("cart.mapping.positions.installationType")],
    netPrice: [get(_)("cart.mapping.positions.netPrice")],
    endCustomerPrice: [get(_)("cart.mapping.positions.endCustomerPrice")],
    endCustomerPriceGross: [get(_)("cart.mapping.positions.endCustomerPriceGross")],
    retailPrice: [get(_)("cart.mapping.positions.retailPrice")],
    alternativeTo: [get(_)("cart.mapping.positions.alternativeTo")],
    objectionPeriodEnd: [get(_)("cart.mapping.positions.objectionPeriodEnd")],
    instructionsAvailable: [get(_)("cart.mapping.positions.instructionsAvailable")],
    specialCAD: [get(_)("cart.mapping.positions.specialCAD")],
    items: [
        get(_)("cart.mapping.positions.items.label"),
        {
            sequenceNumber: [get(_)("cart.mapping.positions.items.sequenceNumber")],
            amount: [get(_)("cart.mapping.positions.items.amount")],
            measureUnit: [get(_)("cart.mapping.positions.items.measureUnit")],
            number: [get(_)("cart.mapping.positions.items.number")],
            description: [get(_)("cart.mapping.positions.items.description")],
        },
    ],
    tracking: [
        get(_)("cart.mapping.positions.tracking.label"),
        {
            sequenceNumber: [get(_)("cart.mapping.positions.tracking.sequenceNumber")],
            trackingNumber: [get(_)("cart.mapping.positions.tracking.trackingNumber")],
            status: [get(_)("cart.mapping.positions.tracking.status")],
            receiver: [get(_)("cart.mapping.positions.tracking.receiver")],
        },
    ],
    chargeable: [get(_)("cart.mapping.positions.chargeable")],
    chargeableReason: [get(_)("cart.mapping.positions.chargeableReason")],
}

/**
 * Translates a dot-separated path into a human-readable format.
 * @param {string} path - The dot-separated path to translate.
 * @returns {string} - The translated path.
 */
export function translatePath(path) {
    // Split the path into components
    /**
     * @type {any}
     */
    let components = path.split(".")
    /**
     * @type {any}
     */
    let currentMap = mappingCart
    let translatedPath = []

    for (let i = 0; i < components.length; i++) {
        let component = components[i]
        let indexMatch = component.match(/(\w+)\[(\d+)\]/)

        if (indexMatch) {
            let key = indexMatch[1]
            let index = parseInt(indexMatch[2])

            translatedPath.push(`${currentMap[key][0]} &rarr; ${index + 1}. ${get(_)("address.entry")}`)

            // If there are subfields, update the current map
            if (currentMap[key].length > 1) {
                currentMap = currentMap[key][1]
            }
        } else if (currentMap[component]) {
            translatedPath.push(currentMap[component][0])

            // If there are subfields, update the current map
            if (currentMap[component].length > 1) {
                currentMap = currentMap[component][1]
            }
        } else {
            // Iterating over the subarray structure if the direct key isn't found.
            let found = false
            for (let key in currentMap) {
                if (currentMap[key][1] && currentMap[key][1][component]) {
                    translatedPath.push(currentMap[key][1][component][0])
                    if (currentMap[key][1][component].length > 1) {
                        currentMap = currentMap[key][1][component][1]
                    }
                    found = true
                    break
                }
            }
            if (!found) {
                console.error(`Key ${component} not found in currentMap path: ${path}`)
                continue
            }
        }
    }

    // Join the translated path components into a sentence
    return translatedPath.join(" &rarr; ")
}
//
